var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconListCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.17 3.33h8.33V5H9.17zm0 3.34h5v1.66h-5zm0 5h8.33v1.66H9.17zm0 3.33h5v1.67h-5zM2.5 3.33h5v5h-5zM4.17 5v1.67h1.66V5zM2.5 11.67h5v5h-5zm1.67 1.66V15h1.66v-1.67z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListCheck);
export default ForwardRef;